module.exports = __webpack_public_path__ + "static/media/service-content.6ec6fa9b.svg";